import React, { useEffect, useRef } from 'react';
interface Star {
  x: number;
  y: number;
  size: number;
  opacity: number;
  speed: number;
}
export function StarField() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let stars: Star[] = [];
    let animationFrameId: number;
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      initStars();
    };
    const initStars = () => {
      stars = [];
      const starCount = Math.floor(canvas.width * canvas.height / 3000);
      for (let i = 0; i < starCount; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 2,
          opacity: Math.random(),
          speed: Math.random() * 0.05
        });
      }
    };
    const drawStars = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // Deep navy background is handled by CSS, but we can add a subtle gradient overlay here if needed
      // For now, we just draw stars
      stars.forEach(star => {
        ctx.fillStyle = `rgba(255, 255, 255, ${star.opacity})`;
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
        ctx.fill();
        // Twinkle effect
        star.opacity += (Math.random() - 0.5) * 0.05;
        if (star.opacity < 0.1) star.opacity = 0.1;
        if (star.opacity > 1) star.opacity = 1;
        // Subtle movement
        star.y -= star.speed;
        if (star.y < 0) star.y = canvas.height;
      });
      animationFrameId = requestAnimationFrame(drawStars);
    };
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    drawStars();
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <canvas ref={canvasRef} className="fixed top-0 left-0 w-full h-full pointer-events-none z-0" style={{
    background: 'linear-gradient(to bottom, #05081c, #0a0e27)'
  }} data-id="element-150" />;
}